import { useQuery } from 'react-query'

import { getConsumingPlaybooks } from 'api/blocks'
import {
  HydratedPlaybookBlockData,
  PlaybookBlockData,
} from 'components/BlockEditorNavigation'

export const useConsumingPlaybooks = (id: string) => {
  const { data, isLoading, error } = useQuery(
    `reusable-block--${id}--playbooks`,
    () => getConsumingPlaybooks(id).then(({ data }) => data)
  )

  return [
    data,
    {
      isLoading,
      error,
    },
  ]
}

export const hydrateConsumingPlaybooks = (
  playbookBlockData: PlaybookBlockData[]
): HydratedPlaybookBlockData[] => {
  const hydrated = playbookBlockData.map(
    ({ isOutdated, playbookStatus, playbookId, playbookName }) => ({
      isOutdated,
      playbook: { id: playbookId, name: playbookName },
      playbookStatus,
    })
  )

  return hydrated as HydratedPlaybookBlockData[]
}
